import { NgModule } from '@angular/core';
import { DeviceManagementComponent } from './device-management.component';
import { DeviceManagementService } from './device-management.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { DeviceRegistrationModalComponent } from './device-registration-modal/device-registration-modal.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		RouterModule,
		MatCardModule,
	],
	declarations: [
		DeviceManagementComponent,
		DeviceRegistrationModalComponent,
	],
	entryComponents: [
		DeviceRegistrationModalComponent,
	],
	providers: [DeviceManagementService]
})
export class DeviceManagementModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/device-management/device-management.module.ts